import { render, staticRenderFns } from "./CustomerBudgetsSelectbox.vue?vue&type=template&id=4f2f0980"
import script from "./CustomerBudgetsSelectbox.vue?vue&type=script&lang=js"
export * from "./CustomerBudgetsSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports